module.exports = __webpack_public_path__ + "img/relief-icon.8aa03f46.png";